import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { Home, Droplets, Layers, Square, Paintbrush, Building2, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function ServicesGrid() {
  const services = [{
    title: 'Roofing & Repairs',
    description: 'Expert roof replacements, tear-offs, and emergency repairs using premium architectural shingles.',
    icon: Home,
    path: '/services/roofing'
  }, {
    title: 'Gutter Services',
    description: 'Seamless gutter installation, cleaning, and advanced gutter protection systems.',
    icon: Droplets,
    path: '/services/gutters'
  }, {
    title: 'Siding Installation',
    description: "Transform your home's exterior with durable vinyl, fiber cement, or wood siding options.",
    icon: Layers,
    path: '/services/siding'
  }, {
    title: 'Window Replacement',
    description: 'Energy-efficient window upgrades that enhance curb appeal and lower utility bills.',
    icon: Square,
    path: '/services/windows'
  }, {
    title: 'Exterior Painting',
    description: "Professional exterior painting services to protect and beautify your home's facade.",
    icon: Paintbrush,
    path: '/services/painting'
  }, {
    title: 'Commercial Roofing',
    description: 'Flat roof solutions including TPO, EPDM, and silicone coatings for local businesses.',
    icon: Building2,
    path: '/commercial'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 bg-gray-50" data-id="element-427">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-428">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-429">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-430">
            Our Exterior Services
          </h2>
          <div className="w-20 h-1 bg-brand-blue mx-auto mb-6 rounded-full" data-id="element-431"></div>
          <p className="font-body text-brand-gray text-lg" data-id="element-432">
            From complete roof replacements to seamless gutters, we provide
            comprehensive exterior solutions tailored to Michigan's unique
            climate.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-433">
          {services.map((service, index) => <motion.div key={index} variants={cardVariants} data-id="element-434">
              <Link to={service.path} className="block bg-white rounded-xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 group border border-gray-100 h-full flex flex-col" data-id="element-435">
                <div className="w-14 h-14 bg-brand-blue/10 rounded-lg flex items-center justify-center mb-6 group-hover:bg-brand-blue transition-colors duration-300" data-id="element-436">
                  <service.icon size={28} className="text-brand-blue group-hover:text-white transition-colors duration-300" data-id="element-437" />
                </div>
                <h3 className="font-heading font-bold text-xl text-brand-gray-dark mb-3 group-hover:text-brand-blue transition-colors" data-id="element-438">
                  {service.title}
                </h3>
                <p className="font-body text-brand-gray mb-6 flex-grow" data-id="element-439">
                  {service.description}
                </p>
                <div className="flex items-center text-brand-blue font-body font-semibold text-sm mt-auto" data-id="element-440">
                  Learn More
                  <ArrowRight size={16} className="ml-2 group-hover:translate-x-2 transition-transform" data-id="element-441" />
                </div>
              </Link>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}